import styled from 'styled-components';
import Icon from '../../assets/images/info-icon.svg';

const InfoIcon = styled.span`
  background: url(\"${Icon}\") no-repeat left center;
  background-size: 25px 25px;
  display: block;
  position: relative;
  width: 30px;
  height: 25px;
`;

export default InfoIcon;
